<template>
  <div class="logout-box">
    <Spin fix>
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>{{ $t('key1006534') }}</div>
    </Spin>
  </div>
</template>

<script>
import {removeToken} from '@/utils/cookie';
import {getQueryString} from '@/utils/common';
export default {
  name: 'logout',
  mixins: [],
  data () {
    return {};
  },
  created () {
    removeToken().then(()=>{
      this.$router.push({
        path: '/login',
        query: {
          u: getQueryString('u')
        }
      });
    });
  },
  methods: {}
};
</script>

<style scoped>
.logout-box {
  width: 100vw;
  height: 100vh;
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
.demo-spin-col{
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>
